import { GenericEvent, MethodMeta } from '@central-products/transport-bus-common';
import { isPromise } from '../utils';

export function convertResultToResponse(m: MethodMeta, domain: string, serviceName: string) {
  return (data: any): GenericEvent => {
    const result = {
      serviceName,
      name: m.name,
      domain,
      payload: data,
    };
    // validatePayload(result, m.response.schema);

    return result;
  };
}

export function callMethod(method: (data: any) => any, payload: any): Promise<any> {
  try {
    const result = method(payload);
    return isPromise(result) ? result : Promise.resolve(result);
  } catch (e) {
    return Promise.reject(e);
  }
}
